export default "__VITE_ASSET__41c696b8__"